<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered">
			<div class="portlet-title">
				<div class="caption">
					Edit Campaign Details
				</div>
			</div>
			<div class="portlet-body">
				<form role="form" @submit.prevent="updateCampaign($event)" novalidate>
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
	                    <span>{{ errorMessage }}</span>
					</div>
					<div class="form-body invite-user-form">
						<div class="margin-bottom-20">
							<div class="form-group form-md-line-input form-md-floating-label no-top-padding">
	                        	<label class="dropdown-label-override">Start On</label>
	            			    <el-date-picker v-model="editingCampaign.start_date" :format="'MMM dd, yyyy h:mm A'" type="datetime" placeholder="Select Start Date*" :editable="false" :picker-options="datepickerStartOptions"></el-date-picker>
	            			</div>
	            			<div class="form-group form-md-line-input form-md-floating-label no-top-padding">
	                        	<label class="dropdown-label-override">End On</label>
	            			    <el-date-picker v-model="editingCampaign.end_date" :format="'MMM dd, yyyy h:mm A'" type="datetime" placeholder="Select End Date*" :editable="false" :picker-options="datepickerEndOptions"></el-date-picker>
	            			</div>
	            		</div>
	            		<div class="form-body invite-user-form">
							<div class="form-actions noborder invite-user-actions margin-top-40">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To UNOgames Dashboard</button>
								<button type="submit" class="btn blue" key="edit-campaign-confirm">Submit</button>
							</div>
						</div>
	            	</div>
	            </form>
			</div>
		</div>
	</div>
</template>
<script>
import GlobalFunctions from '../../../global'
import UNOgames from '../../../controllers/UNOgames'
import { mapGetters } from 'vuex'

/**
 * Edit Campaign Details module is a page for editing the details of the campaign.
 * @class EditCampaignDetails
 * @extends UNOgames
 * @since 0.0.9
 */

export default {
	name: 'edit-campaign-details',
	data () {
		return {
			activePanel: false,
			errorMessage: '',
			campaignId: 0,
			editingCampaign: {
				start_date: new Date(),
				end_date: new Date()
			},
			initialStartDate: new Date(),
			initialEndDate: new Date(),
			datepickerStartOptions: {
				disabledDate: (time) => {
					return time.getTime() < Date.now() - 1000 * 60 * 60 * 24
				}
			},
			datepickerEndOptions: {
				disabledDate: (time) => {
					return time.getTime() < Date.now() - 1000 * 60 * 60 * 24
				}
			}
		}
	},
	created () {
		if (this.$route.name === 'UNOgames - Edit Campaign Details') {
			this.activePanel = true
			if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
				this.campaignId = this.$route.params.campaign_id
				this.getCampaignDetails()
			} else {
				this.closePanel()
			}
		} else {
			this.activePanel = false
		}
	},
	computed: mapGetters([
		'activeLocationId'
	]),
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof EditCampaignDetails
		 * @version 0.0.9
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To close the edit campaign details panel by redirecting to the dashboard.
		 * @function
		 * @returns {undefined}
		 * @memberof EditCampaignDetails
		 * @version 0.0.9
		 */
		closePanel () {
			this.$router.push('/app/uno_games')
		},
		/**
		 * To pull in details for the current campaign.
		 * @function
		 * @returns {undefined}
		 * @memberof EditCampaignDetails
		 * @version 0.0.9
		 */
		getCampaignDetails () {
			let _this = this

			UNOgames.getCampaign(_this.activeLocationId, _this.campaignId).then(response => {
				_this.editingCampaign.start_date = new Date(response.payload.campaign.starts_at)
				_this.initialStartDate = _this.editingCampaign.start_date
				_this.editingCampaign.end_date = new Date(response.payload.campaign.ends_at)
				_this.initialEndDate = _this.editingCampaign.end_date
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To validate that all information is accurate before allowing the user to proceed.
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditCampaignDetails
		 * @version 0.0.9
		 */
		validateFormData () {
			let _this = this

			return new Promise((resolve, reject) => {
				if (_this.editingCampaign.start_date !== _this.initialStartDate && new Date() - _this.newCampaign.start_date > 1200000) {
					// Using 1200000 to give the date breathing room of 20 minutes to complete the form in case user chooses `Now`
					reject('Campaign start date must be past the current date and time')
				}
				if (_this.editingCampaign.end_date < _this.editingCampaign.start_date) {
					reject('Campaign end date must be past the start date and time')
				}

				resolve()
			})
		},
		/**
		 * To send the updated campaign details to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof EditCampaignDetails
		 * @version 0.0.9
		 */
		updateCampaign (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return _this.validateFormData().then(response => {
				_this.clearError()

				let updatedCampaign = {}

				if (_this.editingCampaign.start_date !== _this.initialStartDate) {
					let localStartDate = `${_this.editingCampaign.start_date.getFullYear()}-${_this.editingCampaign.start_date.getMonth() + 1}-${_this.editingCampaign.start_date.getDate()} ${_this.editingCampaign.start_date.getHours()}:${_this.editingCampaign.start_date.getMinutes()}:${_this.editingCampaign.start_date.getSeconds()}`

					updatedCampaign.start_date = localStartDate
				}
				if (_this.editingCampaign.end_date !== _this.initialEndDate) {
					let localEndDate = `${_this.editingCampaign.end_date.getFullYear()}-${_this.editingCampaign.end_date.getMonth() + 1}-${_this.editingCampaign.end_date.getDate()} ${_this.editingCampaign.end_date.getHours()}:${_this.editingCampaign.end_date.getMinutes()}:${_this.editingCampaign.end_date.getSeconds()}`
					updatedCampaign.end_date = localEndDate
				}

				return UNOgames.updateCampaign(_this.activeLocationId, _this.campaignId, updatedCampaign).then(response => {
					_this.closePanel()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				if (reason) {
					_this.errorMessage = reason
				}
				disabledButton.cancel()
			})
		}
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof EditCampaignDetails
		 * @version 0.0.9
		 */
		'$route' () {
			if (this.$route.name === 'UNOgames - Edit Campaign Details') {
				this.activePanel = true
				this.clearError()
				if (this.$route.params.campaign_id && this.$route.params.campaign_id !== 'undefined' && parseInt(this.$route.params.campaign_id) !== 0) {
					this.campaignId = this.$route.params.campaign_id
					this.getCampaignDetails()
				} else {
					this.closePanel()
				}
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// EditCampaignDetails.vue?ba0cf04a